import React, { Component } from 'react';
import {connect} from 'react-redux'
import axios from 'axios'
import ReactSwipe from 'react-swipe'
import { Page } from '../components'
import {WKCurrencyItem, WKSkeletonScreen} from '../components/wk'
import {isLZWKAPP} from '../utils'
import resellBannerImg from '../images/resell/store-banner.jpg'
import "../styles/subject/SubjectPage.css"

class FreeLecturePage extends Component {

    constructor() {
        super()
        this.state = {
            FreeLectureList: [],
            initialized: false,
            bannerList: [
                {
                    img: 'https://static-cos.lycheer.net/picture/4548011_2044075f8cc1cd216da7a1da1088bd63.jpg',
                    id: '1',
                    link: '/specials/coupon?bagid=8&from=wx_share&fr=index_free'
                },
                {
                    img: resellBannerImg,
                    id: '2',
                    link: '/resell?from=index_free'
                },
            ]
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.accountName) {
            this.props.dispatch({
                type: 'UPDATE_SHARE_DATA',
                payload: {
                    title: `${nextProps.accountName} 送了你一套免费课`,
                    desc: '限时1小时内有效，赶紧领取吧～',
                    type: 'link',
                    imgUrl: 'https://static-cos.lycheer.net/picture/7832811_893380d1c4635908af8798b9761234c4.jpg-picmsg420',
                    link: location.href
                }
            });
        }
    }

    componentDidMount() {
        // 解决返回黑屏的问题
        window.scrollTo(0,1)

        document.title = '免费专题';
        axios.get('/api/index/recommend', {
            params: {
                type: 'free_zone'
            }
        }).then(res => {
            this.setState({
                FreeLectureList: res.data.data.recommends,
                initialized: true,
            })
        })
    }

    render() {
        const {FreeLectureList, initialized} = this.state;

        return (
            <Page>
                <div className="subject-page">
                    {!isLZWKAPP() && false &&
                    <ReactSwipe ref="reactSwipe" swipeOptions={{
                        speed: 400,
                        auto: 3000,
                        continuous: true,
                        callback: (index) => this.setState({
                            slidePoint: index
                        })
                    }}>
                        {this.state.bannerList.map((v) =>
                            <div className="subject-page-banner" key={v.id}>
                                <a href={v.link}>
                                    <img src={v.img} alt=""/>
                                </a>
                            </div>
                        )}
                    </ReactSwipe>
                    }

                    {!initialized ?
                        <WKSkeletonScreen num={3}/>
                        :
                        FreeLectureList.map((item) => {
                            return (
                                <div className="subject-page-item" key={item.id}>
                                    <WKCurrencyItem content={item} type="lecture" attr="index_free"/>
                                </div>
                            )
                        })
                    }
                </div>
            </Page>
        )

    }
}

export default connect((state) => ({
    accountName: state.account.nickname
}))(FreeLecturePage)



// WEBPACK FOOTER //
// ./src/pages/FreeLecturePage.js